import { AccessibilityGuidelineVersionService } from './services/accessibility-guideline-version.service';
import { NgModule } from '@angular/core';

@NgModule({
    providers: [AccessibilityGuidelineVersionService],
})
export class AccesibilityModule {}
